import { render, staticRenderFns } from "./EditSimpleOptionLoader.vue?vue&type=template&id=83f2beb4"
import script from "./EditSimpleOptionLoader.vue?vue&type=script&lang=ts"
export * from "./EditSimpleOptionLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports